import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import MyAppCardItem from './MyAppCardItem';
import MyAppRecCardItem from './MyAppRecCardItem';
import getContent from '../lib/dictionaryFetcher';
import Marketplaces from '../../lib/singletons/marketplaces';
import Partners from '../../lib/singletons/partners';

const MyAppCard = props => {
  const {
    app,
    setApp,
    showOffer,
    btnType,
    tools,
    setTool,
    toggleFavorite,
    user
  } = props;

  const toolBtnTextActive = getContent(
      'merchanthub',
      `tools.button.active`,
      ''
    ),
    toolBtnTextInactive = getContent(
      'merchanthub',
      `tools.button.inactive`,
      ''
    );

  const tool = get(tools, `[${app}]`, {}),
    marketplace = get(Marketplaces.instance(), `[${app}]`, {}),
    partners = get(Partners.instance(), `[${app}]`, {}),
    externalPartner = isEmpty(marketplace) ? partners : marketplace,
    isTool = get(tool, 'key', '').includes('pp_'),
    item = isTool ? tool : externalPartner,
    toolBtnText = get(tool, 'active', false)
      ? toolBtnTextActive
      : toolBtnTextInactive,
    btnText = isTool
      ? toolBtnText
      : getContent('merchanthub', `apps.${app}.button`, ''),
    callback = isTool ? setTool : setApp;

  return !isEmpty(item) ? (
    <MyAppCardItem
      app={app}
      user={user}
      item={item}
      btnType={btnType}
      btnText={btnText}
      showOffer={showOffer}
      toggleFavorite={toggleFavorite}
      callback={callback}
    />
  ) : (
    <MyAppRecCardItem app={app} />
  );
};

MyAppCard.propTypes = {
  app: PropTypes.string,
  tools: PropTypes.object,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  showOffer: PropTypes.bool,
  toggleFavorite: PropTypes.func,
  btnType: PropTypes.string,
  user: PropTypes.object
};

export default MyAppCard;
